/**
 * Phase 3 - Hindi translations module
 */
import enBase from './en.js';
import { translationsHi } from '../../utils/translations/translations.hi.js';
import { plansTranslationsHi } from '../../utils/translations/plans/plansTranslations.hi.js';

const merged = { ...enBase, ...translationsHi, ...plansTranslationsHi };
export default merged;
